<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <div class='mb25 s_flex_ali'>
        <span class='mr15'>
          <a-button type="primary" v-has:onlineProductCreate="()=> {$router.push({path:'/onlineOrder/productManage/createone'})}">
            <PlusOutlined />
            添加产品
          </a-button>
        </span>
      </div>
      <a-tabs @change="callback" v-model:active="active">
        <a-tab-pane key="" tab="全部">
        </a-tab-pane>
        <a-tab-pane :key="1" tab="已上架">
        </a-tab-pane>
        <a-tab-pane :key="0" tab="仓库中">
        </a-tab-pane>
      </a-tabs>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="产品名称" name='product_name'>
          <a-input v-model:value="search.product_name" style="width:280px" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="产品分类" name='cat_id'>
          <a-cascader :options="cateList" :field-names="{ label: 'name', value: 'id', children: 'children' }" v-model:value="search.cat_id" placeholder="请选择产品分类" change-on-select />
        </a-form-item>
        <a-form-item label="创建时间" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChangeTime" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <div class="m-b-20">
        {{selectedRowKeys.length?`已选${selectedRowKeys.length}商品`:''}}
        <a-button class="m-r-15" type="primary" ghost v-has:onlineProductAllOff="batchDown" v-if="active!==0">
          批量下架
        </a-button>
        <a-button class="m-r-15" type="primary" ghost v-has:onlineProductAllOff="batchUp" v-if="active!==1">
          批量上架
        </a-button>
        <a-button class="m-r-15" type="primary" ghost v-has:onlineProductAllDel="batchDel" v-if="active!==1">
          删除
        </a-button>
        <a-button class="m-r-15" type="primary" ghost v-has:onlineProductAllSetCate="batchGroup">
          批量设置分组
        </a-button>
      </div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='goods_id' :columns='columns' :data-source='data' :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" class="tableFixBox" :scroll="{ x: 'max-content'}">
        <template v-slot:product_name="{record}">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>
              <p class="s_omit2" style="width:200px">{{record.product_name}}</p>
            </template>
          </a-card-meta>
        </template>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a v-has:onlineProductEdit="()=>$router.push({path:'/onlineOrder/productManage/edit',query:{id:record.id,type:'edit',goods_id:record.goods_id,product_id:record.product_id}})" href="javascript:;">修改</a>
                </a-menu-item>
                <a-menu-item v-if="record.status!=0">
                  <a v-has:onlineProductOff="()=>recovery(record,'off')" href="javascript:;">下架</a>
                </a-menu-item>
                <a-menu-item v-if='record.status!=1'>
                  <a v-has:onlineProductOff="()=>recovery(record,'on')" href="javascript:;">上架</a>
                </a-menu-item>
                <a-menu-item v-if='record.status!=1'>
                  <a v-has:onlineProductDel="()=>del(record)" href="javascript:;">删除</a>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:onlineProductLook="()=>checkSku(record)" href="javascript:;">查看规格</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <div class="s_flex_bian_c m-t-20">
        <div>
          {{selectedRowKeys.length?`已选${selectedRowKeys.length}商品`:''}}
          <a-button class="m-r-15" type="primary" ghost v-has:onlineProductAllOff="batchDown" v-if="active!==0">
            批量下架
          </a-button>
          <a-button class="m-r-15" type="primary" ghost v-has:onlineProductAllOff="batchUp" v-if="active!==1">
            批量上架
          </a-button>
          <a-button class="m-r-15" type="primary" ghost v-has:onlineProductAllDel="batchDel" v-if="active!==1">
            删除
          </a-button>
          <a-button class="m-r-15" type="primary" ghost v-has:onlineProductAllSetCate="batchGroup">
            批量设置分组
          </a-button>
        </div>
        <a-pagination show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
      </div>
    </a-card>
  </a-layout>
  <a-modal v-model:visible="groupVisible" centered title="选择分组" @ok="groupComfirm">
    <a-form-item label="分组">
      <a-cascader :options="cateList" :field-names="{ label: 'name', value: 'id', children: 'children' }" v-model:value="cat_id" placeholder="请选择产品分类" />
    </a-form-item>

  </a-modal>
  <a-modal v-model:visible="skuVisible" centered title="查看规格" :width="1000" :footer="null" destroyOnClose>
      <skuList :options="skuData" />
  </a-modal>
</template>
<script>
import { PlusOutlined, DownOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import skuList from './skuList.vue'
import {
  getProductList,
  getGoodsCategory,
  offSale,
  onSale,
  batchOnSale,
  batchOffSale,
  batchDels,
  goodsDel,
  batchCategory,
} from "@/api/online.js";
import { iscode } from "@/utils/app";
import store from "@/store";
// 初始化默认筛选项数值
let defSearch = {
  product_name: "",
  cat_id: undefined,
  start_time: "",
  end_time: "",
  page: 1,
  limit: 10,
};
export default {
  components: {
    PlusOutlined,
    skuList,
    DownOutlined,
  },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      info: store.state.user.info,
      listLoading: false,
      time: [],
      total: 1,
      active: 1,
      selectedRowKeys: [],
      groupVisible: false, //分组弹框控制
      skuVisible:false,//sku 弹窗控制
    });
    let columns = [
      {
        title: "商品名称",
        dataIndex: "product_name",
        key: "product_name",
        width: 300,
        slots: { customRender: "product_name" },
      },
      {
        title: "商品分组",
        dataIndex: "cat_name",
        key: "cat_name",
      },

      {
        title: "价格/元",
        dataIndex: "product_price",
        key: "product_price",
      },
      {
        title: "单件支付积分",
        dataIndex: "point_price_range",
        key: "point_price_range",
      },
      {
        title: "整箱支付积分",
        dataIndex: "box_point_range",
        key: "box_point_range",
      },
      {
        title: "状态",
        dataIndex: "status",
        key: "status",
        customRender: ({ record }) => {
          return record.status == 1 ? "已上架" : "仓库中";
        },
      },
      {
        title: "排序",
        dataIndex: "sort",
        key: "sort",
      },
      {
        title: "创建时间",
        dataIndex: "created_at",
        key: "created_at",
      },
      {
        title: "操作",
        key: "action",
        fixed:"right",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    const momentTime = inject("momentTime");

    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const recovery = (e, type) => {
      $Modal.confirm({
        centered: true,
        content: `您确定要将该商品${
          type == "off" ? "移入仓库？" : "移出仓库？"
        }`,
        onOk: async () => {
          let res;
          if (type == "off") {
            res = await offSale(e.goods_id).then((res) => res.data);
          } else {
            res = await onSale(e.goods_id).then((res) => res.data);
          }

          if (iscode(res, true)) {
            initData(search.value);
            $Modal.destroyAll();
          }
        },
      });
    };
    const del = (e) => {
      $Modal.confirm({
        centered: true,
        content: `您确定要将该商品删除后无法还原`,
        onOk: async () => {
          let res = await goodsDel(e.goods_id).then((res) => res.data);
          if (iscode(res)) {
            initData(search.value);
            $Modal.destroyAll();
          }
        },
      });
    };
    const reset = () => {
      search.value = { ...defSearch };
    };
    // tabs 点击
    const active = ref(1);
    const callback = (e) => {
      active.value = e;
      reset();
      initData(search.value);
    };
    const form = ref();

    const onSelect = (keys, event) => {
      console.log("Trigger Select", keys, event);
    };
    const initData = async (values) => {
      console.log(values)
      state.listLoading = true;
      try {
        let res = await getProductList({
          start_time:values.start_time,
          end_time:values.end_time,
          page:values.page,
          limit:values.limit,
          status: active.value,
          product_name:search.value.product_name,
          product_category_id:values.cat_id?values.cat_id[values.cat_id.length-1]:'',
          cat_id:values.cat_id?values.cat_id[values.cat_id.length-1]:''
        }).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          console.log(res);
          data.value = res.data;
          state.total = res.meta.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        console.log(e)
        state.listLoading = false;
      }
    };
    // 获取分类
    const cateList = ref([]);
    const getCate = async () => {
      let cateResult = await getGoodsCategory()
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(cateResult)) {
        cateList.value = cateResult.data;
      }
    };
    // 查看规格
    const skuData=ref({})
    const checkSku = (data) => {
      state.skuVisible=true,
      skuData.value=data
    };
    // 切换时间
    const onChangeTime = (e) => {
      if (!e.length) {
        search.value.start_time = "";
        search.value.end_time = "";
      } else {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      }
    };
    const determineRowKeys = () => {
      console.log(state.selectedRowKeys);
      return state.selectedRowKeys.length ? true : false;
    };
    //batchDown 批量下架
    const batchDown = () => {
      if (!determineRowKeys()) {
        message.error("请选择商品");
        return;
      }
      $Modal.confirm({
        centered: true,
        content: `确定选择商品全部下架？`,
        onOk: async () => {
          let res = await batchOffSale({
         ids: state.selectedRowKeys
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(res,true)) {
            state.selectedRowKeys=[]
            initData(search.value);
            $Modal.destroyAll();
          }
        },
      });
    };
    // 批量上架
    const batchUp = () => {
      if (!determineRowKeys()) {
        message.error("请选择商品");
        return;
      }
      $Modal.confirm({
        centered: true,
        content: `确定选择商品全部上架？`,
        onOk: async () => {
          let res = await batchOnSale({
            ids: state.selectedRowKeys
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(res,true)) {
            state.selectedRowKeys=[]

            initData(search.value);
            $Modal.destroyAll();
          }
        },
      });
    };
    //批量删除
    const batchDel = () => {
      if (!determineRowKeys()) {
        message.error("请选择商品");
        return;
      }
      $Modal.confirm({
        centered: true,
        content: `确定选择商品全部删除？`,
        onOk: async () => {
          let res = await batchDels({
           ids: state.selectedRowKeys
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(res,true)) {
            initData(search.value);
            state.selectedRowKeys=[]
            $Modal.destroyAll();
          }
        },
      });
    };
    // 批量分组
    const cat_id = ref("");
    const batchGroup = () => {
      if (!determineRowKeys()) {
        message.error("请选择商品");
        return;
      }
      cat_id.value = "";
      state.groupVisible = true;
    };
    const groupComfirm = async () => {
      if (!cat_id.value.length) {
        return message.error("请选择分组");
      }
      let result = await batchCategory(cat_id.value[cat_id.value.length-1], {
         ids: state.selectedRowKeys
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        initData(search.value);
        state.selectedRowKeys=[]
        state.groupVisible = false;
      }
    };
    onMounted(() => {
      initData(search.value);
      getCate();
    });
    return {
      ...toRefs(state),
      search,
      data,
      checkSku,
      skuData,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      momentTime,
      recovery,
      onSelect,
      callback,
      active,
      reset,
      form,
      cateList,
      del,
      onSelectChange,
      onChangeTime,
      batchDel,
      cat_id,
      batchUp,
      batchDown,
      batchGroup,
      groupComfirm,
    };
  },
};
</script>